import { EllipsisHorizontalIcon } from '@heroicons/react/20/solid';
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import React from 'react';

interface VisibilityProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const Visibility: React.FC<VisibilityProps> = ({ visible, setVisible }) => {
  return (
    <div className="flex items-center gap-s">
      <div className="flex items-center gap-xs">
        <div>
          {visible ? (
            <EyeIcon className="size-l fill-neutral-600" />
          ) : (
            <EyeSlashIcon className="size-l fill-neutral-600" />
          )}
        </div>
        <div className="text-body2Light text-neutral-600">
          {visible ? 'Show on page' : 'Hide from page'}
        </div>
      </div>
      <div className="h-l w-px rounded-xsmall bg-neutral-300"></div>
      <DropdownMenu.Root modal={false}>
        <DropdownMenu.Trigger asChild>
          <button aria-label="Benefits visibilty dropdown">
            <EllipsisHorizontalIcon className="size-xl fill-brandMidnight" />
          </button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Portal>
          <DropdownMenu.Content className="z-20 overflow-hidden rounded-small bg-white shadow-lg">
            <DropdownMenu.RadioGroup value={visible ? 'visible' : 'hidden'}>
              <DropdownMenu.RadioItem
                value="visible"
                className="cursor-pointer p-xs"
                onSelect={() => setVisible(true)}
              >
                <div
                  className={clsx('flex items-center gap-s px-s py-[9px]', {
                    'bg-blue-light': visible,
                  })}
                >
                  <div>
                    <EyeIcon className="size-l fill-brandMidnight" />
                  </div>
                  <div
                    className={clsx('text-body1Light', {
                      'text-brandMidnight': visible,
                      'text-neutral-800': !visible,
                    })}
                  >
                    Show on page
                  </div>
                </div>
              </DropdownMenu.RadioItem>
              <DropdownMenu.RadioItem
                value="visible"
                className="cursor-pointer p-xs"
                onSelect={() => setVisible(false)}
              >
                <div
                  className={clsx('flex items-center gap-s px-s py-[9px]', {
                    'bg-blue-light': !visible,
                  })}
                >
                  <div>
                    <EyeSlashIcon className="size-l fill-brandMidnight" />
                  </div>
                  <div
                    className={clsx('text-body1Light', {
                      'text-brandMidnight': !visible,
                      'text-neutral-800': visible,
                    })}
                  >
                    Hide from page
                  </div>
                </div>
              </DropdownMenu.RadioItem>
            </DropdownMenu.RadioGroup>
          </DropdownMenu.Content>
        </DropdownMenu.Portal>
      </DropdownMenu.Root>
    </div>
  );
};

export default Visibility;
